export const useAuthorizedFetch = (request, opts) => {
        const headers = { Accept: "application/json" }
        const jwtToken = useCookie("auth_token").value
        if (jwtToken) {
          headers["Authorization"] = `Bearer ${jwtToken}`
        }
        
        return $fetch(request, {
                baseURL: useRuntimeConfig().public.baseUrl,
                headers,
                credentials: "include",
                ...opts,
        })
}
